var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../theme-provider';
export const StyledTableCell = styled.td.withConfig({ displayName: "StyledTableCell", componentId: "sc-10gtrlz" }) `border-bottom:${({ theme }) => theme.size.border.light} solid ${({ theme }) => theme.colors.border.divider};padding:${({ theme }) => theme.size.static200} ${({ theme }) => theme.size.static100};overflow-wrap:break-word;white-space:normal;`;
export const TableCell = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return React.createElement(StyledTableCell, Object.assign({}, rest), children);
};
